import StatusPill from "./statusPill";
import React, { useRef } from 'react';
import {
  Users as UsersIcon,
  CheckCircle2,
  XCircle,
  Phone,
  Mail,
  

} from 'lucide-react';

const PendingCard = ({ user, onApprove, onBlock, isMutating }) => (
  <div className="glass-panel rounded-3xl p-4 border border-white/10 flex flex-col gap-3">
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="text-white font-semibold break-words">{user.name || 'N/A'}</p>
        <p className="text-xs text-slate-400 flex items-center gap-1 truncate">
          <Mail className="h-3.5 w-3.5 text-cyan-200 shrink-0" />
          <span className="truncate">{user.email || 'No email'}</span>
        </p>
        <p className="text-xs text-slate-400 flex items-center gap-1 mt-1 truncate">
          <Phone className="h-3.5 w-3.5 text-emerald-200 shrink-0" />
          <span className="truncate">{user.phone || 'No phone'}</span>
        </p>
      </div>
      <div className="shrink-0">
        <StatusPill status="pending" />
      </div>
    </div>
    <div className="flex gap-2">
      <button
        onClick={() => onApprove(user)}
        disabled={isMutating}
        className="flex-1 px-3 py-2 rounded-xl bg-emerald-500/20 text-emerald-100 border border-emerald-400/30 hover:-translate-y-[2px] transition"
      >
        <div className="flex items-center justify-center gap-2 text-sm">
          <CheckCircle2 className="h-4 w-4" />
          Approve
        </div>
      </button>
      <button
        onClick={() => onBlock(user)}
        disabled={isMutating}
        className="flex-1 px-3 py-2 rounded-xl bg-rose-500/15 text-rose-100 border border-rose-400/30 hover:-translate-y-[2px] transition"
      >
        <div className="flex items-center justify-center gap-2 text-sm">
          <XCircle className="h-4 w-4" />
          Block
        </div>
      </button>
    </div>
  </div>
);
export default PendingCard